import { ApplicationRef, inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import {
  DeprecatedIntelligenceSettings,
  DeprecatedIntelligenceSettingsActions,
  DeprecatedIntelligenceSettingsSelectors,
} from '@core/intelligence-data';

@Injectable({ providedIn: 'root' })
/**
 * @deprecated
 * Feature is moved to tellent admin this service will be removed in the future
 */
export class DeprecatedIntelligenceSettingsService {
  private readonly store = inject(Store);
  private readonly appRef = inject(ApplicationRef);
  private readonly intelligenceSettingsState = this.store.selectSignal(
    DeprecatedIntelligenceSettingsSelectors.state,
  );

  public readonly intelligenceSettings = this.store.selectSignal(
    DeprecatedIntelligenceSettingsSelectors.data,
  );

  constructor() {
    this.appRef.whenStable().then(() => this.fetchSettings());
  }

  public getSettings$() {
    return this.store.select(DeprecatedIntelligenceSettingsSelectors.data);
  }

  public fetchIfNotLoaded() {
    const { pending, loaded } = this.intelligenceSettingsState();
    if (pending || loaded) return;

    this.fetchSettings();
  }

  public fetchSettings() {
    this.store.dispatch(DeprecatedIntelligenceSettingsActions.fetch());
  }

  public updateSettings(settings: Partial<DeprecatedIntelligenceSettings>) {
    this.store.dispatch(DeprecatedIntelligenceSettingsActions.update({ payload: settings }));
  }
}
